import * as React from "react";
import { BaseFieldEditor } from "./helper";
import { FieldValueTags } from "typings";
import { RootState } from "~/state";
import { getFieldValues } from "~/state/action";
import { loadFieldValues } from "~/state/field/action";
import ReactTag, { Tag } from "react-tag-autocomplete";
import { connect } from "react-redux";
export interface Props extends BaseFieldEditor
{
    value: FieldValueTags;
    placeholder?: string;
}

interface State
{
    tags: string[];
}

type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (state: RootState, ownProps: Props) => ({
    values: getFieldValues(state, ownProps.field.name) || []
});

const mapDispatchToProps = (dispatch: any, ownProps: Props) => ({
    loadFieldValues: (fieldName: string, valuesUrl: string) => dispatch(loadFieldValues(fieldName, valuesUrl))
});

class Tags extends React.Component<Props & StateProps, State>
{
    state: State = {
        tags: this.props.value && this.props.value.value ? this.props.value.value : []
    };
    
    componentWillMount()
    {
        if (this.props.value && this.props.value.valuesUrl)
        {
            this.props.loadFieldValues(this.props.field.name, this.props.value.valuesUrl);
        }
    }

    componentWillReceiveProps(nextProps: Props)
    {
        
       this.setState({tags: nextProps.value && nextProps.value.value ? nextProps.value.value : []});
    }

    onDelete = (index: number) =>
    {
        const tags = this.state.tags.filter((x, i) => i !== index);
        const fieldValue: FieldValueTags = {...this.props.value, value: tags };
        this.props.onValueChange(fieldValue);
    }

    onNewTag = (tag: Tag) =>
    {
        const fieldValue: FieldValueTags = {...this.props.value, value: [...this.state.tags, tag.name] };
        this.props.onValueChange(fieldValue);
    }

    render()
    {
        const tags: Tag[] = this.state.tags.map(x => ({id: x, name: x }));
        const suggestions: Tag[] = this.props.values.map(x => ({id: x, name: x }));
        return (
            <div>
              <ReactTag tags={tags}
                 suggestions={suggestions}
                 handleDelete={this.onDelete}
                 handleAddition={this.onNewTag}
                 delimiterChars={[",", " "]}
                 allowNew={true}
                 autofocus={false}
                 placeholder={"Type to add tags (press enter after each tag)"}
                
              />
            </div>
        );
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Tags);


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/Tags.tsx